import React from 'react'
import UploadData from '../../client/UploadData'
import V3DataRouteShell from '../data/V3DataRouteShell'

export default function V3UploadDataPage() {
  return (
    <V3DataRouteShell>
      <UploadData visualVariant="v3" />
    </V3DataRouteShell>
  )
}

